import { Injectable } from '@angular/core';
import { DATE_FORMAT } from '@shared/constants';
import { format, parseISO } from 'date-fns';

@Injectable({
	providedIn: 'root'
})
export class FormatDateService {
	formatDate(inputDate: Date | string, stringFormat = DATE_FORMAT.default): string | null {
		if (inputDate) {
			if (typeof inputDate === 'string') {
				return format(parseISO(inputDate), stringFormat);
			} else {
				const transformDate = new Date(inputDate);
				return format(transformDate, stringFormat);
			}
		}
		return null;
	}

	formattoLocalDate(inputDate: Date | string): string | null {
		if (!inputDate) return null;

		const dateObj = typeof inputDate === 'string' ? parseISO(inputDate) : new Date(inputDate);
		return format(dateObj, 'yyyy-MM-dd'); 
	}

	getFormattedTime(time: string | undefined): Date | null {
		if (!time) return null;
		return new Date(`1970-01-01T${time}`);
	}
}
